import axios from './auth.axios';
import { BASE_URL } from '../constants';

class ZoomService {
  getMeetingStatus = meetingId => axios.get(`${BASE_URL}/v1/zoom/status/${meetingId}`);
  getSignature = meetingId => axios.get(`${BASE_URL}/v1/zoom/signature/${meetingId}`);
}

export default ZoomService;
